export default {
  specialCharacters: /[.*+?^${}()|[\]\\]/g,
  /**
   * 영문자(소문자/대문자), 숫자, 특수문자의 조합 (8~16자리)
   * @see https://www.notion.so/koreaspacedata/web-33f5bf4ee1aa407493c59d8737a05563
   */
  password:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[_!@#%^&*-])[A-Za-z\d_!@#%^&*-]{8,16}$/,
  phoneNumber: /^([0-9]{2,3})-([0-9]{3,4})-([0-9]{4})$/,
  businessNumber: /^(\d{3})-(\d{2})-(\d{5})$/,
  subBusinessNumber: /^(\d{4})$/,
  escapeWhiteSpaces: /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, // 문장 양쪽 공백 제거
  escapeFrontWhiteSpace: /^[\s\uFEFF\xA0]+/gi, // 문장 앞쪽 공백 제거
  email:
    /^[A-Za-z0-9!#$%&'*+/=?^"_‘({|})~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^"_‘({|})~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/g,
};
